/*
 * @Descripttion: 行选中的逻辑整理
 * @version:
 * @Author: bbq
 * @Date: 2020-06-15 15:30:43
 * @LastEditors: bbqin
 * @LastEditTime: 2021-10-29 10:21:56
 */

import React, { Component, Fragment } from "react";
import ReactDOM from 'react-dom';

import { isFunction, isArray, isNumber, ViewModel, getLangCode, getSysFieldid } from "@platform/api";

import "./index.less";

let { getGlobalStorage, setGlobalStorage } = ViewModel;

const RowWithHoverCls = 'table-hover-content-row';
const POP_CLASS = '.nc-popconfirm,.for-table-hover-content:not(.u-dropdown-hidden),.nc-dropdown:not(.u-dropdown-hidden),.refer-pop-window.refer-pop-window-show';

/**
 * 行选中逻辑处理
 * @param {*} Table
 */
export default function hoverContent(Table) {
    if (!Table) {
        console.error("缺少Table组件");
    }
    return class MetaTable extends Component {
        constructor(props) {
            super(props);
            let langCode = getLangCode();
            this.langExtend = langCode !== 'tradchn' && langCode !== 'simpchn';
            this.langClass = langCode === 'tradchn' || langCode === 'simpchn' ? '' : 'lang-extend';
            this.active = false;
            // 获取全局的个性化设置数据
            this.nccTable = JSON.parse(getGlobalStorage('localStorage', 'nccTable')) || {};
        }

        mouseOverHandle = e => {
            // console.log(e.target);
            let tableDom = ReactDOM.findDOMNode(this.table);

            let current = e.target,
                rowHover = true;
            let hasPop = document.querySelector(POP_CLASS);
            if (hasPop) {
                return;
            }
            // 自适应高度情况下  u-table-body  空白处也要移除样式
            if (current.className.indexOf('u-table-body') !== -1) {
                rowHover = false;
            } else {
                while (current !== tableDom) {
                    if (current.className.indexOf('u-table-header') !== -1 || current.className.indexOf('u-table-footer') !== -1) {
                        rowHover = false;
                        break;
                    }
                    current = current.parentElement;
                }
            }

            this.hoverContent && (this.hoverContent.style.display = rowHover ? 'block' : 'none');
        }

        // 不知道有没有性能问题，要谨慎啊
        mouseMoveHandle = e => {
            let { hoverContent = true } = this.props;

            if (!hoverContent) {
                return;
            }
            let current = e.target;

            if (!this.active) {
                return;
            }

            let hasPop = document.querySelector(POP_CLASS);
            if (!hasPop) {
                let tableDom = ReactDOM.findDOMNode(this.table);
                if (!tableDom.contains(current)) {
                    this.active = false;
                    this.hoverContent && (this.hoverContent.parentElement.style.display = 'none');
                }
            } else {
                if (!this.hoverContent || (this.hoverContent && this.hoverContent.parentElement.style.display == 'none')) {
                    this.hoverContentBg && this.hoverContentBg.click();
                }
            }

        }

        componentDidMount() {
            let tableDom = ReactDOM.findDOMNode(this.table);
            tableDom && tableDom.addEventListener('mouseover', this.mouseOverHandle);
            document.addEventListener('mousemove', this.mouseMoveHandle);
        }

        componentWillUnmount() {
            let tableDom = ReactDOM.findDOMNode(this.table);
            tableDom && tableDom.removeEventListener('mouseover', this.mouseOverHandle);
            document.removeEventListener('mousemove', this.mouseMoveHandle);
        }

        handleCellMouseDown(record, index, attrcode, col, e) {
            this.mousedown = true;
            return true;
        }

        render() {
            let {
                columns,
                totalColumns,
                rowClassName,
                hoverContent = true, // true
                rowKey,
                hasSelected,
                onCellMouseDown,
                ...others
            } = this.props;

            let ncc_automated = getGlobalStorage("localStorage", "_ncc_automated_");
            if (ncc_automated === '1' || this.nccTable.rowcheckedButton !== 'suspension') {
                hoverContent = false;
            }

            let oprColumn = null;
            let langExtend = this.langExtend;

            if (hoverContent) {
                // 浅拷贝一下，避免出问题
                columns = [...columns];
                let last;
                columns.forEach((item, index) => {
                    if (
                        (item.attrcode === "opr" || item.attrcode === 'operate') &&
                        item.itemtype === "customer" &&
                        item.render && item.visible // 显示隐藏性
                    ) {
                        oprColumn = item;
                        // 移除下
                        columns.splice(index, 1);
                        // 转单
                        totalColumns && totalColumns.splice(index, 1);
                    } else {
                        item.visible && (last = item);
                    }
                });

                // 识别最后一列  加个样式
                if (last) {
                    let cls = ` table-last-column ${this.langClass} `;
                    last.className = last.className || '';
                    last.className = last.className.replace(cls, '');
                    last.className += cls;
                    totalColumns && (totalColumns[totalColumns.length - 1].className += cls);
                    // 加两个事件
                    last.onCellMouseEnter = cellObj => {
                        if (!cellObj || !cellObj.cellDom || !oprColumn) { return; }
                        let langCode = getLangCode();
                        let langExtend = langCode !== 'tradchn' && langCode !== 'simpchn';
                        let cellDom = cellObj.cellDom;
                        // 空白列
                        let $blank = cellDom.parentElement.querySelector('.blankrow');
                        let $cellContent = cellDom.querySelector('.table-cell-wrapper');
                        let $cellIcon = cellDom.querySelector('.table-cell-wrapper .cell-icon');

                        let contentDefaultWidth = langExtend ? 47 : 29;
                        let blankWidth = $blank ? $blank.offsetWidth : 0;
                        if (!$blank || blankWidth > contentDefaultWidth) {
                            if ($cellIcon && $cellIcon.style.right) {
                                $cellContent && ($cellContent.style.paddingRight = '');
                                $cellIcon && ($cellIcon.style.right = '');
                            }
                            return;
                        }

                        $cellContent && ($cellContent.style.paddingRight = `${contentDefaultWidth}px`);
                        $cellIcon && ($cellIcon.style.right = `${contentDefaultWidth + 7}px`);
                    };
                    last.onCellMouseLeave = cellObj => {
                        if (!cellObj || !cellObj.cellDom) { return; }
                        let cellDom = cellObj.cellDom;
                        // 空白列
                        let $cellContent = cellDom.querySelector('.table-cell-wrapper');
                        let $cellIcon = cellDom.querySelector('.table-cell-wrapper .cell-icon');
                        $cellContent && ($cellContent.style.paddingRight = `0px`);
                        $cellIcon && ($cellIcon.style.paddingRight = `0px`);
                    };
                }
            }

            return (
                <div className="use-hover-content">
                    <Table
                        columns={columns}
                        ref={table => this.table = table}
                        totalColumns={totalColumns}
                        rowKey={rowKey}
                        onBodyMouseLeave={() => {
                            // console.log('onBodyMouseLeave');
                        }}
                        hasSelected={hasSelected}
                        // 特殊情况背景计算在滚动时会触发问题，特殊背景计算只有在点击checkbox是有问题，所以做一下逻辑修正
                        onCellMouseDown={(record, index, attrcode, col, e) => {
                            let res = onCellMouseDown ? onCellMouseDown(record, index, attrcode, col, e) : true;
                            return res !== false && this.handleCellMouseDown(record, index, attrcode, col, e);
                        }}
                        rowClassName={(record, current) => {
                            let cls = `  ${RowWithHoverCls}  `;
                            cls += isFunction(rowClassName) ? rowClassName(record, current) : rowClassName;
                            return cls;
                        }}

                        hoverContent={
                            oprColumn && hoverContent
                                ? (record, index) => {
                                    if (!record || !isNumber(index) || index < 0) {
                                        return null;
                                    }
                                    // console.log(record, index);
                                    let isSelected = hasSelected && hasSelected({ record, rowKey, rowKeyValue: record[rowKey], rowIndex: index });
                                    let tableDom = ReactDOM.findDOMNode(this.table);
                                    // let tableBody = tableDom && tableDom.querySelector('.u-table');
                                    let width = tableDom && tableDom.offsetWidth;
                                    let height = tableDom && tableDom.offsetHeight;
                                    this.hoverContentBg.style.width = width - 2 + 'px';
                                    this.hoverContentBg.style.height = height - 2 + 'px';
                                    let $trs = tableDom.querySelectorAll('.u-table-body tr');
                                    let color = null;
                                    if ($trs) {
                                        let $tr = null;
                                        for (const iterator of $trs) {
                                            let trIndex = iterator && iterator.getAttribute('data-row-index');
                                            if (trIndex == index) {
                                                $tr = iterator;
                                                break; // 避免合计行的一条数据影响第一行的样式
                                            }
                                        }

                                        if ($tr) {
                                            if (this.mousedown) {
                                                console.log('特殊情况下计算hoverContent样式');
                                                $tr.className = $tr.className.replace('table-row-selected', ' ');
                                                $tr.className = isSelected && (($tr.className || '') + ' table-row-selected ');
                                                this.mousedown = false;
                                            }
                                            color = getComputedStyle($tr).backgroundColor;
                                        }
                                    }
                                    return <div
                                        key="hoverContent"
                                        style={color ? { backgroundColor: color } : {}}
                                        className={`hover-content ${isSelected ? ' hover-content-selected ' : ''}`}
                                        ref={dom => this.hoverContent = dom}
                                        fieldid={getSysFieldid('opr')}
                                        onWheel={event => {
                                            let { currentTarget, deltaX, deltaY } = event;
                                            if (Math.abs(deltaX) < Math.abs(deltaY)) {
                                                console.log('wheel trigger');
                                                try {
                                                    let tableDom = ReactDOM.findDOMNode(this.table);
                                                    let $scrollElement = tableDom.querySelector('.u-table-body');
                                                    if ($scrollElement) {
                                                        event.preventDefault();
                                                        window.updateTrigger = true;
                                                        $scrollElement.scrollTop = $scrollElement.scrollTop + deltaY;
                                                        // currentTarget.parentNode.scrollTop = $scrollElement.parentNode.scrollTop + deltaY;
                                                        window.requestAnimationFrame(() => {
                                                            console.log('updateTrigger');
                                                            window.updateTrigger = false;
                                                        });
                                                    } else {
                                                        window.updateTrigger = false;
                                                    }
                                                } catch (error) {
                                                    console.error(error);
                                                    window.updateTrigger = false;
                                                }
                                            }
                                        }}
                                        onMouseLeave={e => {
                                            let hasPop = document.querySelector(POP_CLASS);
                                            if (hasPop) {
                                                e.stopPropagation();
                                                e.preventDefault();
                                            }
                                        }}
                                        onMouseOver={e => {
                                            this.active = true;
                                            let hasPop = document.querySelector(POP_CLASS);
                                            // console.log(hasPop);
                                            if (hasPop) {
                                                this.hoverContentBg && (this.hoverContentBg.style.display = 'block');
                                            }
                                        }}
                                        onClick={e => {
                                            let hasPop = document.querySelector(POP_CLASS);
                                            // console.log(hasPop);
                                            if (hasPop) {
                                                this.hoverContentBg && (this.hoverContentBg.style.display = 'block');
                                            }
                                        }}
                                        onMouseDown={e => {
                                            let target = e.target;
                                            let hasPop = target && (target.parentElement.className.indexOf('popconfirm-hotkeys-wrapper') !== -1 || target.className.indexOf('popconfirm-hotkeys-wrapper') !== -1);
                                            // console.log(hasPop);
                                            if (hasPop) {
                                                this.hoverContentBg && (this.hoverContentBg.style.display = 'block');
                                            }
                                        }}
                                    >
                                        {record ? oprColumn.render("", record, index) : ""}
                                    </div>;
                                }
                                : undefined
                        }
                        {...others}
                    />
                    <div
                        ref={dom => this.hoverContentBg = dom}
                        key="hoverContentBg"
                        onMouseMove={e => {
                            let hasPop = document.querySelector(POP_CLASS);
                            if (!hasPop) {
                                this.hoverContentBg && (this.hoverContentBg.style.display = 'none');
                            } else {
                                this.hoverContent && (this.hoverContent.parentElement.style.display = 'block');
                            }
                        }}
                        onClick={e => {
                            this.hoverContentBg && (this.hoverContentBg.style.display = 'none');
                        }}
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: 0,
                            height: 0,
                            zIndex: 8,
                            display: 'none',
                        }}
                    ></div>
                </div >
            );
        }
    };
}
